import src from "IMAGE";
export default { src, width: 1128, height: 337, blurWidth: 0, blurHeight: 0};
